import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext();

export const LANGS = [
  { code: "en", label: "EN" },
  { code: "de", label: "DE" },
  { code: "it", label: "IT" },
  { code: "fr", label: "FR" },
];

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("kenosis_lang") || "en");

  useEffect(() => {
    localStorage.setItem("kenosis_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  // t returns nested value by dot path; falls back to EN, then to the key
  const t = (path) => {
    const resolve = (obj) =>
      path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);
    const val = resolve(translations[lang]);
    if (val !== undefined) return val;
    const fallback = resolve(translations.en);
    return fallback !== undefined ? fallback : path;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => useContext(LanguageContext);
